import { render } from "./ssq-number.vue?vue&type=template&id=aab30eca&scoped=true"
import script from "./ssq-number.vue?vue&type=script&lang=js"
export * from "./ssq-number.vue?vue&type=script&lang=js"

import "./ssq-number.vue?vue&type=style&index=0&id=aab30eca&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aab30eca"]])

export default __exports__